import type { Epic } from 'Flux/index.js'
import { orderSlice } from 'Flux/Slice/Order/OrderSlice.js'
import { catchError, filter, mergeMap, of, withLatestFrom } from 'rxjs'

export const GetPipelineStateEpic: Epic = (action$, state$, { [orderSlice.name]: order, OrderRepository }) =>
  action$.pipe(
    filter(order.fetchPipelineState.match),
    withLatestFrom(state$),
    mergeMap(([action]) => {
      return OrderRepository.getPostprocessingState(action.payload.orderId).pipe(
        mergeMap((response) => of(order.fetchPipelineStateResult({ result: response }))),
        catchError((error: Error) => {
          console.warn('error fetching postprocessing data, this may just indicate its not there yet', error)
          return of(order.fetchPipelineStateResult({ result: null }))
        })
      )
    })
  )
